<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.payroute_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/pay/payroute';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        sarchShow: true,
        searchMenuSpan: 6,
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        column: [
          {
            label: 'APPID',
            prop: 'appid',
            rules: [
              {
                required: true,
                message: '请输入应用ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付渠道',
            prop: 'payPlatform',

            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=payChannel',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            search: true,
            rules: [
              {
                required: true,
                message: '请输入支付渠道',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付渠道英文',
            prop: 'payPlatformId',
            labelWidth: 110,
            hide: true,
            search: true,
            rules: [
              {
                required: false,
                message: '请输入支付渠道英文',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付渠道中文',
            prop: 'payPlatformName',
            labelWidth: 110,
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入支付渠道中文',
                trigger: 'change',
              },
            ],
          },
          {
            label: '图片类型',
            prop: 'iconType',
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入图片类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '图片样式',
            prop: 'iconClass',
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入图片样式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '图片路径',
            prop: 'iconSrc',
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入图片路径',
                trigger: 'change',
              },
            ],
          },
          {
            label: '活动描述',
            prop: 'noticeDesc',
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入活动描述',
                trigger: 'change',
              },
            ],
          },
          {
            label: '活动描述样式',
            prop: 'descClass',
            labelWidth: 110,
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入活动描述样式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付限额',
            prop: 'payLimit',
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入支付限额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '是否显示',
            prop: 'isDisable',

            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=payYesOrNo',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: [
              {
                required: true,
                message: '请输入是否显示',
                trigger: 'change',
              },
            ],
          },
          {
            label: '是否推荐',
            prop: 'isRecommend',

            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=payYesOrNo',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: [
              {
                required: true,
                message: '请输入是否推荐',
                trigger: 'change',
              },
            ],
          },
          {
            label: '状态',
            prop: 'payRouteStatus',

            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=switch',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            search: true,

            rules: [
              {
                required: true,
                message: '请输入支付路由状态',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.payroute_add, false),
        viewBtn: this.vaildData(this.permission.payroute_view, false),
        delBtn: this.vaildData(this.permission.payroute_delete, false),
        editBtn: this.vaildData(this.permission.payroute_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
